import axios from 'axios';
import qs from 'qs';
import { omit, set, noop, partial, cloneDeep, mapKeys } from 'lodash-es';
import md5 from 'js-md5';
import { getUrlParam, getOSType, isInHeybox, showMessage } from '@heybox-webapp/utils';

// 值为数字型的属性的值
var HbClientConfigNumberState;
(function (HbClientConfigNumberState) {
    HbClientConfigNumberState["YES"] = "1";
    HbClientConfigNumberState["NO"] = "0";
})(HbClientConfigNumberState || (HbClientConfigNumberState = {}));
/**
 * 默认的参数配置
 * 显式定义避免使用时不清晰
 */
const __DEFAULT_REQUEST_CONFIG__ = {
    cancel_http_redirect: HbClientConfigNumberState.NO,
    need_encrypt: HbClientConfigNumberState.YES,
    show_toast: HbClientConfigNumberState.YES,
    add_client_pkey: HbClientConfigNumberState.YES,
    jsInWeb: true,
    needCookie: true,
    discard_client_params: false,
};
var Method$1;
(function (Method) {
    Method["GET"] = "get";
    Method["POST"] = "post";
    Method["PUT"] = "put";
    Method["DELETE"] = "delete";
    Method["PATCH"] = "patch";
})(Method$1 || (Method$1 = {}));

function getURLPathname(url) {
    const regex = /^(?:https?:\/\/[^\/?#]+)?(\/[^?#]*)/;
    const match = url.match(regex);
    return match ? match[1] : '/'; // 如果没有匹配，返回 '/'
}
function generateRandomCharSequence(length, characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
function convertProtocolObjToStr(protocol) {
    return `heybox://${encodeURIComponent(JSON.stringify(protocol))}`;
}
function executeProtocol(protocol_type, protocol_body = {}) {
    let protocol = {
        protocol_type,
        ...protocol_body,
    };
    console.log('[HbRest:ClientReuest:protocol]', protocol);
    if (window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.hbProtocol) {
        window.webkit.messageHandlers.hbProtocol.postMessage(protocol);
    }
    else if (window.local_obj && window.local_obj.hbProtocol) {
        window.local_obj.hbProtocol(('heybox://' +
            encodeURIComponent(JSON.stringify(protocol))));
    }
    else {
        window.location.href =
            'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    }
}
function executeProtocolPromisify(config, callback_property_path = 'jsCallbackFunc') {
    let callback_func_name = generateRandomCharSequence(20, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz');
    let _resolve;
    const promise = new Promise((resolve) => (_resolve = resolve));
    //@ts-ignore
    window[callback_func_name] = function (data) {
        console.log(callback_func_name);
        delete window[callback_func_name];
        _resolve(data);
    };
    set(config, callback_property_path, callback_func_name);
    executeProtocol(config.protocol_type, omit(config, ['protocol_type']));
    return promise;
}
/**
 * 当协议执行后打开了别的页面返回时执行
 * @param config
 * @returns
 */
function executeProtocolPromisifyWhenBack(config) {
    let _resolve;
    const promise = new Promise((resolve) => (_resolve = resolve));
    const old_back_func = window.PageVisibleFromOthersPage;
    window.PageVisibleFromOthersPage = () => {
        _resolve(null);
        old_back_func();
        window.PageVisibleFromOthersPage = old_back_func;
    };
    executeProtocol(config.protocol_type, omit(config, ['protocol_type']));
    return promise;
}
function generateCookieString(cookies) {
    return Object.entries(cookies)
        .map(([key, value]) => `${key}=${value}`)
        .join('; ');
}
/**
 * 加载script脚本
 * @param src
 * @returns
 */
function loadScriptOnce(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            return resolve('');
        }
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve('');
        script.onerror = (err) => reject(err);
        document.body.appendChild(script);
    });
}
function isProd() {
    let href = window.location.href;
    return (href.includes('file://') ||
        href.includes('xiaoheihe') ||
        href.includes('maxjia'));
}

// abeghimnopqrstuw
const V = ['a', 'b', 'e', 'g', 'h', 'i', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'w'];

function x1 (x) {
  if (x & 0x80) {
    return (((x << 1) ^ 0x1B) & 0xFF)
  }
  return x << 1
}

function x2 (x) {
  return (x1(x) ^ x)
}

function x3 (x) {
  return (x2(x1(x)))
}

function x4 (x) {
  return x3(x2(x1(x)))
}

function xe (x) {
  return (x4(x) ^ x3(x) ^ x2(x))
}

function xx (col) {
  let tmp = [0, 0, 0, 0];
  tmp[0] = xe(col[0]) ^ x4(col[1]) ^ x3(col[2]) ^ x2(col[3]);
  tmp[1] = x2(col[0]) ^ xe(col[1]) ^ x4(col[2]) ^ x3(col[3]);
  tmp[2] = x3(col[0]) ^ x2(col[1]) ^ xe(col[2]) ^ x4(col[3]);
  tmp[3] = x4(col[0]) ^ x3(col[1]) ^ x2(col[2]) ^ xe(col[3]);
  col[0] = tmp[0];
  col[1] = tmp[1];
  col[2] = tmp[2];
  col[3] = tmp[3];
  return col
}

function gencode(path, time, nonce) {
  path = `/${path
    .split('/')
    .filter((_) => _)
    .join('/')}/`;
  //AB45STUVWZEFGJ6CH01D237IXYPQRKLMN89
  const charset = 'AB45STUVWZEFGJ6CH01D237IXYPQRKLMN89';

  const transformedTime = xt6(String(time), charset, -2);
  const transformedPath = xt4(path, charset);
  const transformedNonce = xt4(nonce, charset);

  const combinedStr = combineStrings([
    transformedTime,
    transformedPath,
    transformedNonce,
  ]).slice(0, 20);
  const hash = md5(combinedStr);

  let sign = `${
    sum(
      xx(
        hash
          .slice(-6)
          .split('')
          .map((_) => _.charCodeAt()),
      ),
    ) % 100
  }`;
  sign = sign.length < 2 ? `0${sign}` : sign;
  const signaturePart = xt6(hash.substring(0, 5), charset, -4);
  const finalSignature = `${signaturePart}${sign}`;
  return finalSignature;
}

// 确定性变换字符串
function xt6(str, charset, offset) {
  let transformedStr = '',
    t = charset.slice(0, offset);
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    const newIndex = charCode % t.length;
    transformedStr += t[newIndex];
  }
  return transformedStr;
}
function xt4(str, charset) {
  let transformedStr = '';
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    const newIndex = charCode % charset.length;
    transformedStr += charset[newIndex];
  }
  return transformedStr;
}

// 组合字符串
function combineStrings(strings) {
  let combinedStr = '';
  for (let i = 0; i < Math.max(...strings.map((s) => s.length)); i++) {
    strings.forEach((str) => {
      if (i < str.length) {
        combinedStr += str[i];
      }
    });
  }
  return combinedStr;
}

function sum(arr) {
  return arr.reduce((p, c) => {
    return p + c;
  }, 0);
}

const G = {
  a(url, time, nonce) {
    return gencode(url, time - 1, nonce);
  },
  b(url, time, nonce) {
    return gencode(url, time - 2, nonce);
  },
  c(url, time, nonce) {
    return gencode(url, time - 3, nonce);
  },
  d(url, time, nonce) {
    return gencode(url, time - 4, nonce);
  },
  e(url, time, nonce) {
    return gencode(url, time - 5, nonce);
  },
  f(url, time, nonce) {
    return gencode(url, time, nonce);
  },
  g(url, time, nonce) {
    return gencode(url, time + 1, nonce);
  },
  h(url, time, nonce) {
    return gencode(url, time + 2, nonce);
  },
  i(url, time, nonce) {
    return gencode(url, time + 3, nonce);
  },
  j(url, time, nonce) {
    return gencode(url, time + 4, nonce);
  },
  k(url, time, nonce) {
    return gencode(url, time + 5, nonce);
  },
  l(url, time, nonce) {
    return gencode(`/${url}/`, time - 1, nonce);
  },
  m(url, time, nonce) {
    return gencode(`/${url}/`, time - 2, nonce);
  },
  w() {
    return new Date();
  },
  n(url, time, nonce) {
    return gencode(`/${url}/`, time - 3, nonce);
  },
  o(url, time, nonce) {
    return gencode(`/${url}/`, time - 4, nonce);
  },
  p(url, time, nonce) {
    return gencode(`/${url}/`, time - 5, nonce);
  },
  q(url, time, nonce) {
    return gencode(`/${url}/`, time, nonce);
  },
  r(url, time, nonce) {
    return gencode(`/${url}/`, time + 1, nonce);
  },
  s(url, time, nonce) {
    return gencode(`/${url}/`, time + 2, nonce);
  },
  t(url, time, nonce) {
    return gencode(`/${url}/`, time + 3, nonce);
  },
  u(url, time, nonce) {
    return gencode(`/${url}/`, time + 4, nonce);
  },
  v(url, time, nonce) {
    return gencode(`/${url}/`, time + 5, nonce);
  },
};

const __DEFAULT_PARAMS__ = {
	os_type: 'web',
  app: 'heybox',
  client_type: 'mobile',
	version: '999.0.4',
	x_client_type: 'web',
	x_os_type: getOSType(),
	x_app: getUrlParam('x_app') || 'heybox',
	heybox_id: getUrlParam('heybox_id') || '-1'
};

// 999.0.4
function getHBWebV4Params (pathname) {
  let t, k, n,  M = V[3];
  t = ~~(+(G.w())/1000);
  n = md5(t + Math.random(new Date().getTime()).toString()).toLocaleUpperCase();
  k = G[M](pathname, t, n);
  return {
    [`${V[4]}k${V[2]}y`]: k,
    [`_${V[13]}${V[5]}${V[6]}${V[2]}`]: t,
    [`${V[7]}${V[8]}${V[7]}c${V[2]}`]: n,
  }
}

/**
 * @fileoverview 处理数美token初始化
 * @description 获取并set x_xhh_tokenid, 并提供一个重新设置cookie的方法
 * @author 董佳乐
 * @date 2025-02-05
 */
function getSMToken(args = {}, data) {
    let url = '/rc/box_data/callback';
    return HbAxiosRequest.$post(url, args, data);
}
// 获取数美脚本src
function getSMSrc() {
    var originHost = 'static.fengkongcloud.com';
    var isHttps = 'https:' === document?.location?.protocol;
    var protocol = isHttps ? 'https://' : 'http://';
    var fpJsPath = '/dist/web/v3.0.0/fp.min.js';
    var jsTimer = '?t=' + (new Date().getTime() / (6 * 3600 * 1000)).toFixed(0);
    var url = protocol + window._smConf.staticHost + fpJsPath + jsTimer;
    var ua = navigator?.userAgent?.toLowerCase();
    var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
    var isLowIE = /msie\s[678]\.0/.test(ua);
    if (isHttps && isWinXP && isLowIE) {
        url = protocol + originHost + fpJsPath + jsTimer;
    }
    return url;
}
// 注入脚本
function injectSMScript() {
    var url = getSMSrc();
    var sm = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    sm.src = url;
    s.parentNode.insertBefore(sm, s);
}
function getXHHToken(data) {
    return getSMToken({}, {
        box_data: data,
    }).then(({ data }) => {
        if (data.status != 'ok')
            return data.msg;
        return data.result.heybox_token;
    });
}
async function setXHHTokenIdToCookie(xhh_token_id) {
    if (!xhh_token_id) {
        throw new Error('xhh_token_id 不能为空');
    }
    if (typeof xhh_token_id !== 'string') {
        throw new TypeError('xhh_token_id 应该为string');
    }
    var now = new Date();
    now.setTime(now.getTime() + 14 * 24 * 60 * 60 * 1000);
    document.cookie =
        'x_xhh_tokenid=' +
            escape(xhh_token_id) +
            ';expires=' +
            now.toGMTString() +
            ';path=/;domain=' +
            (window?.location?.host?.indexOf('xiaoheihe.cn') >= 0
                ? 'xiaoheihe.cn'
                : 'debugmode.cn');
}
async function setXHHTokenID(sdk) {
    let data = sdk.getDeviceId(); // box_data | box_id
    let xhh_token_id = '';
    if (data.startsWith('B') && data.length === 89) {
        // data 为 boxId
        xhh_token_id = data;
    }
    if (data.startsWith('D')) {
        // data 为 boxData
        xhh_token_id = await getXHHToken(data);
    }
    if (!xhh_token_id) {
        throw new Error('tokenid创建失败');
    }
    setXHHTokenIdToCookie(xhh_token_id);
    return xhh_token_id;
}
function init() {
    window._smConf = {
        organization: '0yD85BjYvGFAvHaSQ1mc', //必填，组织标识，邮件中organization项
        appId: 'heybox_website', //必填，应用标识，默认传值default，其他应用标识提前联系数美协助定义
        publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXj9exmI4nQjmT52iwr+yf7hAQ06bfSZHTAHUfRBYiagCf/whhd8es0R79wBigpiHLd28TKA8b8mGR8OiiI1hV+qfynCWihvp3mdj8MiiH6SU3lhro2hkfYzImZB0RmWr2zE4Xt1+A6Oyp6bf+W7JSxYUXHw3nNv7Td4jw4jEFKQIDAQAB', //必填，私钥标识，邮件中publicKey项
        staticHost: 'static.portal101.cn',
        protocol: 'https',
    };
    let resolve = noop;
    let promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
    });
    window._smReadyFuncs = [
        () => {
            resolve(window.SMSdk);
        },
    ];
    window.SMSdk = {};
    injectSMScript();
    return promise;
}
let setXHHTokenIDWithSDK = noop;
async function initSM() {
    const SMSdk = await init();
    setXHHTokenID(SMSdk);
    setXHHTokenIDWithSDK = partial(setXHHTokenID, SMSdk);
    window.setXHHTokenID = setXHHTokenIDWithSDK;
}

/**
 * @fileoverview 处理show_captcha时的二次验证
 * @description 使用腾讯的机器验证API进行验证并返回验证后的参数
 * @author 董佳乐
 * @date 2025-02-05
 */
let show_caputure_promise;
async function handleShowCapture() {
    await loadScriptOnce('https://turing.captcha.qcloud.com/TCaptcha.js');
    if (show_caputure_promise) {
        return show_caputure_promise;
    }
    else {
        show_caputure_promise = new Promise((resolve, reject) => {
            const captcha = new window.TencentCaptcha('2061805035', (q_res) => {
                if (q_res.ret == 0) {
                    resolve({
                        ticket: q_res.ticket,
                        randstr: q_res.randstr,
                        captcha_type: 'confirm',
                    });
                    setTimeout(() => {
                        show_caputure_promise = null;
                    }, 10 * 60 * 1000);
                }
                else {
                    reject({
                        status: 'frontend_failed',
                        result: {},
                        msg: '验证失败',
                    });
                    setTimeout(() => {
                        show_caputure_promise = null;
                    });
                }
            });
            captcha.show();
        });
        return show_caputure_promise;
    }
}

// 处理请求域名
function handleRequesHost(axios) {
    axios.interceptors.request.use((config) => {
        if (config.auto_transform_xiaoheihe_host) {
            config.url = window.location.origin.replace(/(.*?:\/\/)(.*?)\.(.*?)(\..*)/, (url, protocol, prefix_host, host, suffix_host) => {
                let temp_host = '';
                if (host == 'xiaoheihe') {
                    temp_host = protocol + 'api.' + host + suffix_host;
                }
                else if (host == 'debugmode') {
                    temp_host = protocol + 'heybox.' + host + suffix_host;
                }
                return temp_host + getURLPathname(config.url);
            });
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
}
// 添加公共参数
function handleRequesVitalParams(axios) {
    axios.interceptors.request.use((config) => {
        config.params = {
            ...__DEFAULT_PARAMS__,
            ...getHBWebV4Params(getURLPathname(config.url)),
            ...config.params,
        };
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
}
// 处理通用返回状态
function handleResponseStatusParams(axios) {
    axios.interceptors.response.use(async (res) => {
        let _data = res.data;
        if (_data && _data.status) {
            if (_data.status === 'lack_token') {
                await setXHHTokenIDWithSDK();
                if (res.config.need_recall) {
                    return axios(Object.assign({}, res.config, {
                        need_recall: false,
                    }));
                }
            }
            if (_data.status === 'show_captcha') {
                const captcha_params = await handleShowCapture();
                if (res.config.need_recall) {
                    return axios(Object.assign({}, res.config, {
                        need_recall: false,
                        params: {
                            ...res.config.params,
                            ...captcha_params,
                        },
                    }));
                }
            }
            if (_data.status === 'name_verify' ||
                _data.status === 'need_alipay_verify' ||
                _data.status === 'need_bind_phone' ||
                _data.status === 'need_phone_code') {
                if (isInHeybox()) {
                    await executeProtocolPromisifyWhenBack({
                        protocol_type: 'openAuthentication',
                        type: _data.status,
                    });
                    if (res.config.need_recall) {
                        return axios(Object.assign({}, res.config, {
                            need_recall: false,
                        }));
                    }
                    // executeProtocol('openAuthentication', {
                    //   type: _data.status,
                    // });
                }
            }
            if (_data.status === 'login' || _data.status === 'relogin') {
                if (isInHeybox()) {
                    await executeProtocolPromisifyWhenBack({
                        protocol_type: 'login',
                    });
                    if (res.config.need_recall) {
                        return axios(Object.assign({}, res.config, {
                            need_recall: false,
                        }));
                    }
                    // executeProtocol('login');
                }
                else {
                    window.open(isProd() ? 'login.xiaoheihe.cn' : 'login.debugmode.cn');
                }
            }
            if (_data.status === 'failed' && _data.msg && res.config.show_toast) {
                if (isInHeybox()) {
                    showMessage('failed', res.data.msg);
                }
            }
        }
        return res;
    }, (error) => {
        return Promise.reject(error);
    });
}
/**
 * 处理分支
 */
function handleRylaiserviceTag(axios, tag_config) {
    // X-Rylai-Service-Tag
    axios.interceptors.request.use((config) => {
        if (tag_config) {
            const { default_tag, special_tag } = tag_config;
            if (default_tag) {
                config.headers['X-Rylai-Service-Tag'] = default_tag;
            }
            if (special_tag) {
                let pathname = getURLPathname(config?.url ?? '');
                if (special_tag.path_prefix_list.some((prefix) => pathname.startsWith(prefix))) {
                    config.headers['X-Rylai-Service-Tag'] = special_tag.tag_name;
                }
            }
        }
        return config;
    }, (err) => {
        console.log(err);
    });
}
function setupInterceptor(axios) {
    handleRequesHost(axios);
    handleRequesVitalParams(axios);
    handleResponseStatusParams(axios);
}

const REQUEST_TIMEOUT_MS = 10000;
// 处理ContentType, method为POST时需要添加 content-type: application/x-www-form-urlencoded;charset=UTF-8
const handleContentType = function (data, headers) {
    if (!headers.getContentType() && data) {
        headers.setContentType('application/x-www-form-urlencoded;charset=UTF-8');
    }
    return data;
};
// 处理post请求的表单数据
const handleDataForm = function (data, headers) {
    const content_type = headers.getContentType();
    if (content_type?.includes('x-www-form-urlencoded') && typeof data === 'object') {
        data = qs.stringify({ ...data }, { indices: false });
    }
    if (content_type?.includes('multipart/form-data') && typeof data === 'object' && !(data instanceof FormData)) {
        data = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            data.set(key, value);
        });
    }
    return data;
};
const HbAxiosRequest = axios.create({
    withCredentials: true,
    transformRequest: [handleContentType, handleDataForm],
    timeout: REQUEST_TIMEOUT_MS,
    need_recall: true,
});
// 设置拦截器
setupInterceptor(HbAxiosRequest);
HbAxiosRequest.$get = function (url, params, config) {
    return HbAxiosRequest.get(url, {
        params,
        ...config,
    });
};
HbAxiosRequest.$post = function (url, params, data, config) {
    return HbAxiosRequest.post(url, data, {
        params,
        ...config,
    });
};

class ClientRequestError {
    name = 'ClientRequestError';
    message;
    code;
    response;
    request;
    config;
    status;
    constructor(response) {
        this.message = response.statusText ?? "";
        this.code = "ERR_BAD_REQUEST";
        this.response = response;
        this.request = response.client_request_raw;
        this.config = response.config;
        this.status = response.status;
    }
}

let UID = 0;
var Method;
(function (Method) {
    Method["GET"] = "get";
    Method["POST"] = "post";
    Method["PUT"] = "put";
    Method["DELETE"] = "delete";
    Method["PATCH"] = "patch";
})(Method || (Method = {}));
/**
 * 1. Cookie序列化
 * 2. 将所有的headers的key转成小写 (Android端 BUG, header内部key用大写会闪退)
 */
function handleHeaders(headers) {
    let _headers = cloneDeep(headers);
    if (_headers.Cookie && typeof _headers.Cookie !== 'string') {
        _headers.Cookie = generateCookieString(_headers.Cookie);
    }
    _headers = mapKeys(_headers, function (value, key) {
        return key.toLocaleLowerCase();
    });
    return _headers;
}
/**
 * 处理config问题
 */
function handleConfig(config) {
    let data = {
        id: UID++,
    };
    if (config.headers) {
        config.headers = handleHeaders(config.headers);
    }
    if (config.success_protocol) {
        data.success = convertProtocolObjToStr(config.success_protocol);
        delete config.success_protocol;
    }
    if (config.failed_protocol) {
        data.failed = convertProtocolObjToStr(config.failed_protocol);
        delete config.failed_protocol;
    }
    const common_omit_params = [
        'method',
        'discard_client_params',
        'data',
        'params',
    ];
    switch (config.method) {
        case Method.GET: {
            if (config.discard_client_params) {
                data = {
                    type: 'RAW_GET',
                    query: config.params,
                    ...data,
                    ...omit(config, [...common_omit_params]),
                };
            }
            else {
                data = {
                    type: 'GET',
                    query: config.params,
                    ...data,
                    ...omit(config, [...common_omit_params]),
                };
            }
            break;
        }
        case Method.POST: {
            if (config.discard_client_params) {
                data = {
                    type: 'RAW_POST',
                    body: config.data ?? {},
                    query: config.params,
                    ...data,
                    ...omit(config, [...common_omit_params]),
                };
            }
            else {
                data = {
                    type: 'POST',
                    body: config.data ?? {},
                    query: config.params,
                    ...data,
                    ...omit(config, [...common_omit_params]),
                };
            }
            break;
        }
        default: {
            data = {
                type: 'RAW',
                body: config.data,
                query: config.params,
                ...data,
                ...omit(config, [...common_omit_params]),
            };
        }
    }
    return Object.assign({}, __DEFAULT_REQUEST_CONFIG__, data);
}
function HbClientRequest(config) {
    let params = {
        protocol_type: 'sendRequestV2',
        ...handleConfig(config),
    };
    return executeProtocolPromisify(params)
        .then((res) => {
        if ((res.responseStatus &&
            (res.responseStatus < 200 || res.responseStatus > 300)) ||
            res.error) {
            return Promise.reject(new ClientRequestError({
                config,
                data: res.content ?? {},
                headers: res.responseHeaders,
                status: res.responseStatus || (res.content ? 200 : 0),
                statusText: res.error ?? '',
                client_request_raw: params,
                client_response_raw: res,
            }));
        }
        else {
            return Promise.resolve({
                config,
                data: res.content ?? {},
                headers: res.responseHeaders,
                status: res.responseStatus || (res.content ? 200 : 0),
                statusText: res.error ?? '',
                client_request_raw: params,
                client_response_raw: res,
            });
        }
    })
        .then(async (res) => {
        let _data = res.data;
        if (_data && _data.status) {
            if (_data.status === 'lack_token') {
                await executeProtocolPromisify({
                    protocol_type: 'openAuthentication',
                }, 'callback_js');
                if (res.config.need_recall) {
                    return await HbClientRequest(Object.assign({}, res.config, {
                        need_recall: false,
                    }));
                }
            }
            if (_data.status === 'show_captcha') {
                const captcha_params = await handleShowCapture();
                if (res.config.need_recall) {
                    return await HbClientRequest(Object.assign({}, res.config, {
                        need_recall: false,
                        params: {
                            ...config.params,
                            ...captcha_params,
                        },
                    }));
                }
            }
            if (_data.status === 'name_verify' ||
                _data.status === 'need_alipay_verify' ||
                _data.status === 'need_bind_phone' ||
                _data.status === 'need_phone_code') {
                await executeProtocolPromisifyWhenBack({
                    protocol_type: 'openAuthentication',
                    type: _data.status,
                });
                if (res.config.need_recall) {
                    return await HbClientRequest(Object.assign({}, res.config, {
                        need_recall: false,
                    }));
                }
            }
            if (_data.status === 'login' || _data.status === 'relogin') {
                await executeProtocolPromisifyWhenBack({
                    protocol_type: 'login',
                });
                if (res.config.need_recall) {
                    return await HbClientRequest(Object.assign({}, res.config, {
                        need_recall: false,
                    }));
                }
            }
        }
        return res;
    });
}
HbClientRequest.$get = (url, params, config) => {
    return HbClientRequest({
        method: Method.GET,
        url,
        params,
        ...config,
    });
};
HbClientRequest.$post = (url, params, data, config) => {
    return HbClientRequest({
        method: Method.POST,
        url,
        params,
        data,
        ...omit(config, ['url', 'method']),
    });
};

initSM();

export { HbAxiosRequest, HbClientConfigNumberState, HbClientRequest, Method$1 as Method, __DEFAULT_REQUEST_CONFIG__, handleRylaiserviceTag, handleShowCapture, setXHHTokenIDWithSDK, setupInterceptor };
